//#region 
import {
  ANAL_BASIC_INFO_ERROR,
  ANAL_BASIC_INFO_SUCCESS,
  ANAL_COMPANY_BASIC_ERROR,
  ANAL_COMPANY_BASIC_SUCCESS,
  ANAL_COMPANY_BIGTRANS_ERROR,
  ANAL_COMPANY_BIGTRANS_SUCCESS,
  ANAL_COMPANY_EVENTS_ERROR,
  ANAL_COMPANY_EVENTS_SUCCESS,
  ANAL_COMPANY_HOLDER_ERROR,
  ANAL_COMPANY_HOLDER_SUCCESS,
  ANAL_COMPANY_INTRODUCTION_ERROR,
  ANAL_COMPANY_INTRODUCTION_SUCCESS,
  ANAL_COMPANY_LEADER_ERROR,
  ANAL_COMPANY_LEADER_SUCCESS,
  ANAL_COMPANY_RELATED_ERROR,
  ANAL_COMPANY_RELATED_SUCCESS,
  ANAL_COMPANY_SAME_IND_ERROR,
  ANAL_COMPANY_SAME_IND_SUCCESS,
  ANAL_DEL_FILTER_ERROR,
  ANAL_DEL_FILTER_REQUESTING,
  ANAL_DEL_FILTER_SUCCESS,
  ANAL_FILTER_ACT_ERROR,
  ANAL_FILTER_ACT_REQUESTING,
  ANAL_FILTER_ACT_SUCCESS,
  ANAL_FILTER_RANGE_ERROR,
  ANAL_FILTER_RANGE_SUCCESS,
  ANAL_FS_RATIO_ERROR,
  ANAL_FS_RATIO_SUCCESS,
  ANAL_INDEX_REAL_ERROR,
  ANAL_INDEX_REAL_SUCCESS,
  ANAL_LICH_SU_GIA_ERROR,
  ANAL_LICH_SU_GIA_SUCCESS,
  ANAL_NN_10DAY_ERROR,
  ANAL_NN_10DAY_SUCCESS,
  ANAL_NN_INDAY_ERROR,
  ANAL_NN_INDAY_SUCCESS,
  ANAL_PB_DONG_TIEN_ERROR,
  ANAL_PB_DONG_TIEN_SUCCESS,
  ANAL_RANK_FS_RATIO_ERROR,
  ANAL_RANK_FS_RATIO_SUCCESS,
  ANAL_SEC_LIST_ALL_ERROR,
  ANAL_SEC_LIST_ALL_SUCCESS,
  ANAL_SEC_OVERVIEW_ERROR,
  ANAL_SEC_OVERVIEW_SUCCESS,
  ANAL_STOCK_MATCH_PRICE_ERROR,
  ANAL_STOCK_MATCH_PRICE_SUCCESS,
  ANAL_STOCK_MB_ACTIVE_ERROR,
  ANAL_STOCK_MB_ACTIVE_SUCCESS,
  ANAL_STOCK_REAL_ERROR,
  ANAL_STOCK_REAL_SUCCESS,
  ANAL_USER_FILTER_ERROR,
  ANAL_USER_FILTER_REQUESTING,
  ANAL_USER_FILTER_SUCCESS,
  ANAL_USER_SIGNAL_ERROR,
  ANAL_USER_SIGNAL_REQUESTING,
  ANAL_USER_SIGNAL_SUCCESS,
} from './constants';

const initialState = {
  analStReal: null,
  analStMatchPrice: null,
  analStMBActive: null,
  analBasicInfo: null,

  analIndReal: null,
  analNNInday: null,
  analNN10day: null,
  analPBDongTien: null,
  analLichSuGia: null,
  analFSRatio: null,
  analRankFSRatio: null,
  analSecOverview: null,
  
  analComIntroduction: null,
  analComBasic: null,
  analComSameInd: null,
  analComLeader: null,
  analComHolder: null,
  analComEvents: null,
  analComBigTrans: null,
  analComRelated: null,

  analFilterRange: null,
  analFilterAct: null,
  analFilterActLoading: false,
  analUserFilter: null,

  analUserSignal: null,
  secListAll: null,
  analDelFilter: null,
};

//#endregion

const reducer = function summaryReducer(state = initialState, action) {
  switch (action.type) {
    
    case ANAL_SEC_LIST_ALL_ERROR:
      return {
        ...state,
        secListAll: null,
      };

    case ANAL_SEC_LIST_ALL_SUCCESS:
      return {
        ...state,
        secListAll: action.resData,
      };

// case ANAL_STOCK_REAL_REQUESTING:
    case ANAL_STOCK_REAL_ERROR:
      return {
        ...state,
        analStReal: null,
      };

    case ANAL_STOCK_REAL_SUCCESS:
      return {
        ...state,
        analStReal: action.resData,
      };

    // case ANAL_STOCK_MATCH_PRICE_REQUESTING:
    case ANAL_STOCK_MATCH_PRICE_ERROR:
      return {
        ...state,
        analStMatchPrice: null,
      };

    case ANAL_STOCK_MATCH_PRICE_SUCCESS:
      return {
        ...state,
        analStMatchPrice: action.resData,
      };

    // case ANAL_STOCK_MB_ACTIVE_REQUESTING:
    case ANAL_STOCK_MB_ACTIVE_ERROR:
      return {
        ...state,
        analStMBActive: null,
      };

    case ANAL_STOCK_MB_ACTIVE_SUCCESS:
      return {
        ...state,
        analStMBActive: action.resData,
      };
      
    case ANAL_BASIC_INFO_ERROR:
      return {
        ...state,
        analBasicInfo: null,
      };

    case ANAL_BASIC_INFO_SUCCESS:
      return {
        ...state,
        analBasicInfo: action.resData,
      };

    // case ANAL_INDEX_REAL_REQUESTING:
    case ANAL_INDEX_REAL_ERROR:
      return {
        ...state,
        analIndReal: null,
      };

    case ANAL_INDEX_REAL_SUCCESS:
      return {
        ...state,
        analIndReal: action.resData,
      };

    // case ANAL_NN_INDAY_REQUESTING:
    case ANAL_NN_INDAY_ERROR:
      return {
        ...state,
        analNNInday: null,
      };

    case ANAL_NN_INDAY_SUCCESS:
      return {
        ...state,
        analNNInday: action.resData,
      };

    // case ANAL_NN_10DAY_REQUESTING:
    case ANAL_NN_10DAY_ERROR:
      return {
        ...state,
        analNN10day: null,
      };

    case ANAL_NN_10DAY_SUCCESS:
      return {
        ...state,
        analNN10day: action.resData,
      };

    // case ANAL_PB_DONG_TIEN_REQUESTING:
    case ANAL_PB_DONG_TIEN_ERROR:
      return {
        ...state,
        analPBDongTien: null,
      };

    case ANAL_PB_DONG_TIEN_SUCCESS:
      return {
        ...state,
        analPBDongTien: action.resData,
      };

    // case ANAL_LICH_SU_GIA_REQUESTING:
    case ANAL_LICH_SU_GIA_ERROR:
      return {
        ...state,
        analLichSuGia: null,
      };

    case ANAL_LICH_SU_GIA_SUCCESS:
      return {
        ...state,
        analLichSuGia: action.resData,
      };

    // case ANAL_FS_RATIO_REQUESTING:
    case ANAL_FS_RATIO_ERROR:
      return {
        ...state,
        analFSRatio: null,
      };

    case ANAL_FS_RATIO_SUCCESS:
      return {
        ...state,
        analFSRatio: action.resData,
      };

    // case ANAL_RANK_FS_RATIO_REQUESTING:
    case ANAL_RANK_FS_RATIO_ERROR:
      return {
        ...state,
        analRankFSRatio: null,
      };

    case ANAL_RANK_FS_RATIO_SUCCESS:
      return {
        ...state,
        analRankFSRatio: action.resData,
      };

    // case ANAL_SEC_OVERVIEW_REQUESTING:
    case ANAL_SEC_OVERVIEW_ERROR:
      return {
        ...state,
        analSecOverview: null,
      };

    case ANAL_SEC_OVERVIEW_SUCCESS:
      return {
        ...state,
        analSecOverview: action.resData,
      };

    // case ANAL_COMPANY_INTRODUCTION_REQUESTING:
    case ANAL_COMPANY_INTRODUCTION_ERROR:
      return {
        ...state,
        analComIntroduction: null,
      };

    case ANAL_COMPANY_INTRODUCTION_SUCCESS:
      return {
        ...state,
        analComIntroduction: action.resData,
      };

    // case ANAL_COMPANY_BASIC_REQUESTING:
    case ANAL_COMPANY_BASIC_ERROR:
      return {
        ...state,
        analComBasic: null,
      };

    case ANAL_COMPANY_BASIC_SUCCESS:
      return {
        ...state,
        analComBasic: action.resData,
      };

    // case ANAL_COMPANY_SAME_IND_REQUESTING:
    case ANAL_COMPANY_SAME_IND_ERROR:
      return {
        ...state,
        analComSameInd: null,
      };

    case ANAL_COMPANY_SAME_IND_SUCCESS:
      return {
        ...state,
        analComSameInd: action.resData,
      };

    // case ANAL_COMPANY_LEADER_REQUESTING:
    case ANAL_COMPANY_LEADER_ERROR:
      return {
        ...state,
        analComLeader: null,
      };

    case ANAL_COMPANY_LEADER_SUCCESS:
      return {
        ...state,
        analComLeader: action.resData,
      };

    // case ANAL_COMPANY_HOLDER_REQUESTING:
    case ANAL_COMPANY_HOLDER_ERROR:
      return {
        ...state,
        analComHolder: null,
      };

    case ANAL_COMPANY_HOLDER_SUCCESS:
      return {
        ...state,
        analComHolder: action.resData,
      };

    // case ANAL_COMPANY_EVENTS_REQUESTING:
    case ANAL_COMPANY_EVENTS_ERROR:
      return {
        ...state,
        analComEvents: null,
      };

    case ANAL_COMPANY_EVENTS_SUCCESS:
      return {
        ...state,
        analComEvents: action.resData,
      };

    // case ANAL_COMPANY_BIGTRANS_REQUESTING:
    case ANAL_COMPANY_BIGTRANS_ERROR:
      return {
        ...state,
        analComBigTrans: null,
      };

    case ANAL_COMPANY_BIGTRANS_SUCCESS:
      return {
        ...state,
        analComBigTrans: action.resData,
      };

    // case ANAL_COMPANY_RELATED_REQUESTING:
    case ANAL_COMPANY_RELATED_ERROR:
      return {
        ...state,
        analComRelated: null,
      };

    case ANAL_COMPANY_RELATED_SUCCESS:
      return {
        ...state,
        analComRelated: action.resData,
      };

    // case ANAL_FILTER_RANGE_REQUESTING:
    case ANAL_FILTER_RANGE_ERROR:
      return {
        ...state,
        analFilterRange: null,
      };

    case ANAL_FILTER_RANGE_SUCCESS:
      return {
        ...state,
        analFilterRange: action.resData,
      };

    case ANAL_FILTER_ACT_REQUESTING:
      return {
        ...state,
        analFilterAct: null,
        analFilterActLoading: true,
      };

    case ANAL_FILTER_ACT_ERROR:
      return {
        ...state,
        analFilterAct: null,
        analFilterActLoading: false,
      };

    case ANAL_FILTER_ACT_SUCCESS:
      return {
        ...state,
        analFilterAct: action.resData,
        analFilterActLoading: false,
      };

    // case ANAL_USER_FILTER_REQUESTING:
    case ANAL_USER_FILTER_ERROR:
      return {
        ...state,
        analUserFilter: null,
      };

    case ANAL_USER_FILTER_SUCCESS:
      return {
        ...state,
        analUserFilter: action.resData,
      };

    case ANAL_USER_SIGNAL_REQUESTING:
    case ANAL_USER_SIGNAL_ERROR:
      return {
        ...state,
        analUserSignal: null,
      };

    case ANAL_USER_SIGNAL_SUCCESS:
      return {
        ...state,
        analUserSignal: action.resData,
      };

    case ANAL_DEL_FILTER_REQUESTING:
    case ANAL_DEL_FILTER_ERROR:
      return {
        ...state,
        analDelFilter: null,
      };

    case ANAL_DEL_FILTER_SUCCESS:
      return {
        ...state,
        analDelFilter: action.resData,
      };

    default:
      return state;
  }
};

export default reducer;
